import {
  MRT_GlobalFilterTextInput,
  MRT_ShowHideColumnsButton,
  MantineReactTable,
  useMantineReactTable,
} from 'mantine-react-table'
import { useTranslation } from 'react-i18next'
import { getLocalization } from '../../../widgets/LanguageSelect/lib/consts'
import { useSessionHistoryTable } from '../lib/use-session-history-table'
import clsx from 'clsx'

interface Props {
  currentUserId?: number
}

export const SessionHistoryTable = ({ currentUserId }: Props) => {
  const {
    pagination,
    columns,
    fetchedSessionHistory,
    isErrorSessionHistory,
    isFetchingSessionHistory,
    isLoadingSessionHistory,
    totalRowCount,
    sorting,
    setSorting,
    setPagination,
    columnFilters,
    setColumnFilters,
    search,
    handleSearchChange,
  } = useSessionHistoryTable(currentUserId)
  const { t, i18n } = useTranslation()
  const localization = getLocalization(i18n.language)

  const table = useMantineReactTable({
    columns,
    data: fetchedSessionHistory,
    enableStickyHeader: false,
    enableColumnActions: false,
    manualPagination: true,
    onPaginationChange: setPagination,
    rowCount: totalRowCount,
    manualSorting: true,
    onSortingChange: setSorting,
    enableEditing: false,
    localization,
    enableRowActions: false,
    manualFiltering: true,
    onColumnFiltersChange: setColumnFilters,
    columnFilterDisplayMode: 'popover',
    enableColumnFilters: true,
    mantineSearchTextInputProps: {
      placeholder: t('userManagement:search'),
      value: search || '',
      onChange: e => handleSearchChange(e.target.value),
    },
    onGlobalFilterChange: handleSearchChange,
    renderTopToolbar: ({ table }) => {
      return (
        <div
          className={clsx(
            'flex flex-row items-center mb-2',
            !currentUserId ? 'justify-between' : 'justify-end',
          )}
        >
          {!currentUserId && <MRT_GlobalFilterTextInput table={table} />}
          <div className='flex flex-row items-center space-x-2'>
            <MRT_ShowHideColumnsButton className='h-[2.5rem] w-[2.5rem] rounded-md' table={table} />
          </div>
        </div>
      )
    },
    mantinePaperProps: {
      shadow: 'none',
      withBorder: false,
    },
    mantineTableProps: {
      sx: {
        tableLayout: 'auto',
      },
    },
    mantineTableBodyProps: {
      sx: {
        '&: td': {
          minWidth: 90,
        },
        '& tr:hover': {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    mantineTableBodyRowProps: {
      className: 'hover:bg-[#F4FAFD]/10',
    },
    state: {
      isLoading: isLoadingSessionHistory,
      pagination,
      sorting,
      columnFilters,
      showGlobalFilter: true,
      columnVisibility: {
        user__fullname: !currentUserId,
      },
      showAlertBanner: isErrorSessionHistory,
      showProgressBars: isFetchingSessionHistory,
    },
  })

  return <MantineReactTable table={table} />
}
